export function limitArrayLength(array, length = 100) {
  if (array.length > length) {
    return array.slice(array.length - length);
  }
  return array;
}
